import React from 'react'
import { Spin } from 'antd'
import './PartialLoading.css'

export const PartialLoading = () => (
  <div className="loader-wrapper">
    <Spin size='large' />
  </div>
)
